import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/app/admin-settings/info")({
  beforeLoad: (context) => {
    return {
      getTitle: () => context.context.t && context.context.t("AdminInfo"),
    }
  },
  component: Outlet,
})
